import React, { useState, useEffect } from 'react';
// تأكد من استدعاء ملف الـ CSS الذي سننشئه
import '../styles/GrassAnimation.css'; 

// دالة مساعدة لتوليد رقم عشوائي ضمن نطاق معين
const random = (min, max) => Math.random() * (max - min) + min;

// عدد شفرات العشب التي نريد عرضها - زيادة الكثافة
const NUM_GRASS_BLADES = 200;

function GrassAnimation() {
  const [grassBlades, setGrassBlades] = useState([]);

  useEffect(() => {
    const newBlades = [];
    for (let i = 0; i < NUM_GRASS_BLADES; i++) {
      newBlades.push({
        id: i,
        style: {
          // قيم عشوائية لكل شفرة عشب لتبدو طبيعية - أطول
          height: `${random(50, 100)}px`, // طول أطول (من 50 إلى 100 بكسل)
          marginLeft: `${random(-5, 5)}px`, // تداخل أقل للمزيد من الكثافة
          marginRight: `${random(-3, 3)}px`, // مسافة جانبية إضافية
          animationDelay: `${random(0, -5)}s`, // تأخير عشوائي للحركة (سر الطبيعية)
          animationDuration: `${random(1.5, 3)}s`, // سرعة حركة عشوائية أبطأ قليلاً
        }
      });
    }
    setGrassBlades(newBlades);
  }, []); // [] تعني أن هذا الـ effect يعمل مرة واحدة فقط عند تحميل المكون

  return (
    <div className="grass-container">
      {grassBlades.map(blade => (
        <span 
          key={blade.id} 
          className="grass-item" 
          style={blade.style} 
        />
      ))}
    </div>
  );
}

export default GrassAnimation;